import {dynamic} from '@github-ui/dynamic'
import {withLazyAppBoundary} from '@github-ui/react-core/lazy-app-boundary'

import type {ActionsWorkflowsRouteComponents} from './create-actions-workflows-routes'

export const lazyActionsWorkflowsRouteComponents: ActionsWorkflowsRouteComponents = {
  AllWorkflowRuns: withLazyAppBoundary(
    dynamic(async () => {
      const module = await import('./route-components')
      return {default: module.AllWorkflowRuns}
    }),
  ),
  AllWorkflowRunsError: withLazyAppBoundary(
    dynamic(async () => {
      const module = await import('./route-components')
      return {default: module.AllWorkflowRunsError}
    }),
  ),
  WorkflowRuns: withLazyAppBoundary(
    dynamic(async () => {
      const module = await import('./route-components')
      return {default: module.WorkflowRuns}
    }),
  ),
  WorkflowRunsError: withLazyAppBoundary(
    dynamic(async () => {
      const module = await import('./route-components')
      return {default: module.WorkflowRunsError}
    }),
  ),
  WorkflowsLayout: withLazyAppBoundary(
    dynamic(async () => {
      const module = await import('./route-components')
      return {default: module.WorkflowsLayout}
    }),
  ),
}
